/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import { MAIN_ICON_COLORS } from 'assets/components';
import CurrencyIcon from '../../../components/CurrencyIcon';
import Icon from '../../../components/Icon';
import { ICONS } from '../../../components/Icon/constants';
import { dynamicAssets } from '../../../utilities/helpers';
import { useUsEnv } from '../../../utilities/sharedHooks/useUsEnv';

const CardInfoBanner = ({ onCloseClick, isCryptoDraftBannerEnabled }) => {
  const { t: translate } = useTranslation();

  const { isUsEnv } = useUsEnv();

  const cardInfo3Note = useMemo(
    () => (isUsEnv ? translate('card_info_us_sub_body_3') : translate('card_info_sub_body_3')),
    [isUsEnv, translate]
  );

  const cardInfo4Note = useMemo(
    () => (isUsEnv ? translate('card_info_us_sub_body_4') : translate('card_info_sub_body_4')),
    [isUsEnv, translate]
  );

  return (
    <div className={`bg-lighter  mb-4 position-relative rounded-extra ${isBrowser ? 'p-4' : ''}`}>
      {isBrowser && (
        <div className="position-absolute top-0 end-0 p-4">
          <i
            onClick={onCloseClick}
            onKeyDown={onCloseClick}
            role="button"
            className="close-btn text-f4 cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </div>
      )}

      <div className="d-flex flex-column">
        <span className={`text-f4  ${isBrowser ? 'mt-2' : ''}`}>
          {isCryptoDraftBannerEnabled
            ? translate('cryptodraft_info_title')
            : translate('card_info_title')}
        </span>
        <span className={`text-f5  ${isBrowser ? 'mt-3' : 'mt-2'}`}>
          {isCryptoDraftBannerEnabled
            ? translate('cryptodraft_info_subtitle')
            : translate('card_info_subtitle')}
        </span>
        <span className="text-shadow text-f6 mt-2">
          {isCryptoDraftBannerEnabled
            ? translate('cryptodraft_info_body')
            : translate('card_info_body')}
        </span>
        <div
          className={`d-flex justify-content-between my-4 ${
            isBrowser ? 'flex-row ' : 'flex-column '
          }`}>
          <div
            className={`d-flex flex-column p-4 bg-light rounded-extra w-100 ${
              isBrowser ? ' mx-2' : 'my-2 '
            }`}>
            {isCryptoDraftBannerEnabled ? (
              <div className="d-flex flex-row ">
                <CurrencyIcon currencyCode="btc" style={{ width: '1.5rem', height: '1.5rem' }} />
                <CurrencyIcon
                  currencyCode="eth"
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                />
              </div>
            ) : (
              <div className="d-flex flex-row ">
                <CurrencyIcon currencyCode="btc" style={{ width: '1.5rem', height: '1.5rem' }} />
                <CurrencyIcon
                  currencyCode="eth"
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                />
              </div>
            )}

            <span className="mt-3 text-f6">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_1')
                : translate('card_info_sub_body_1')}
            </span>
            <span className="mt-3 text-f6 text-shadow">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_2')
                : translate('card_info_sub_body_2')}
            </span>
          </div>
          <div
            className={`d-flex flex-column p-4 bg-light rounded-extra w-100 ${
              isBrowser ? ' mx-2' : 'my-2 '
            }`}>
            {isCryptoDraftBannerEnabled ? (
              <div className="d-flex flex-row ">
                <CurrencyIcon currencyCode="eur" style={{ width: '1.5rem', height: '1.5rem' }} />
                <CurrencyIcon
                  currencyCode="usd"
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                />
              </div>
            ) : (
              <div className="d-flex flex-row ">
                <CurrencyIcon currencyCode="btc" style={{ width: '1.5rem', height: '1.5rem' }} />
                <CurrencyIcon
                  currencyCode="usdt"
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                />
                <CurrencyIcon
                  currencyCode="bxx"
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                />
              </div>
            )}
            <span className="mt-3 text-f6">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_3')
                : cardInfo3Note}
            </span>
            <span className="mt-3 text-f6 text-shadow">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_4')
                : cardInfo4Note}
            </span>
          </div>
          <div
            className={`d-flex flex-column p-4 bg-light rounded-extra w-100 ${
              isBrowser ? ' mx-2' : 'my-2 '
            }`}>
            {isCryptoDraftBannerEnabled ? (
              <div style={{ width: '1.5rem', height: '1.5rem' }}>
                <Icon icon={ICONS.WALLET} color={MAIN_ICON_COLORS.WHITE} />
              </div>
            ) : (
              <div className="d-flex flex-row ">
                <img
                  src={dynamicAssets('./assets/images/starbucks.svg')}
                  style={{ width: '1.5rem', height: '1.5rem' }}
                  alt="starbucks"
                />
                <img
                  src={dynamicAssets('./assets/images/uber.svg')}
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                  alt="uber"
                />
                <img
                  src={dynamicAssets('./assets/images/nike.svg')}
                  style={{ width: '1.5rem', height: '1.5rem', marginLeft: '3px' }}
                  alt="nike"
                />
              </div>
            )}

            <span className="mt-3 text-f6">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_5')
                : translate('card_info_sub_body_5')}
            </span>
            <span className="mt-3 text-f6 text-shadow">
              {isCryptoDraftBannerEnabled
                ? translate('cryptodraft_info_sub_body_6')
                : translate('card_info_sub_body_6')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardInfoBanner;

CardInfoBanner.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isCryptoDraftBannerEnabled: PropTypes.bool,
};

CardInfoBanner.defaultProps = {
  isCryptoDraftBannerEnabled: false,
};
